import React from "react";
import clsx from "clsx";
import styles from "../../styles/components/organisms/Unfold.module.scss";

interface UnfoldProps {
  className?: string;
  children?: any;
  open?: boolean;
  max?: boolean;
  flex?: boolean;
}

export default function Unfold(props: UnfoldProps) {
  const { className, open, max, flex, children } = props;
  const classes = clsx(
    styles.unfold,
    { [styles.open]: open },
    { [styles.max]: max },
    { [styles.flex]: flex },
    className
  );
  return <div className={classes}>{children}</div>;
}
